module.exports = __webpack_public_path__ + "img/SLOL.e51d0e95.svg";